import './../css/GSideBar.css';
import './../css/GPostJob.css';
import './../css/GMediaQuery.css';
import './../css/Gtop.css';
import './../css/GAnimetion.css';
import './../css/GFooter.css';
import './../css/GPage2.css';
import './../css/GPage3.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {systemConfiguration} from "../../../src/CommonImports";

function GJobSingleInfo() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';
    return (
        <>
                        <div className="GSingle-image-feature">
                                <figure>
                                    <img alt="jobhub" src={mediaUrl + "img-job-feature.png?" + sasToken} className="img-fluid rounded-15" />

                                </figure>
                            </div>  
                        <div className="GContent-single">
                                <h5>The AliStudio Team</h5>
                                <p>
                                    The AliStudio Design team has a vision to establish a trusted platform that enables
                                    productive and healthy enterprises in a world of digital and remote everything,
                                    constantly changing work patterns and norms, and the need for organizational resiliency.
                                </p>
                                <p>
                                    The ideal candidate will have strong creative skills and a portfolio of work that
                                    demonstrates their passion for illustrative design and typography. This candidate will
                                    have experience in working with numerous different design platforms such as digital and
                                    print forms.
                                </p>
                                <h5>Essential Knowledge, Skills, and Experience</h5>
                                <ul>
                                    <li>A portfolio demonstrating well-thought-out and polished end-to-end customer journeys
                                    </li>
                                    <li>5+ years of industry experience in interactive design and/or visual design</li>
                                    <li>Excellent interpersonal skills</li>
                                    <li>Aware of trends in mobile, communications, and collaboration</li>
                                    <li>Ability to create highly polished design prototypes, mockups, and other
                                        communication artifacts</li>
                                    <li>The ability to scope and estimate efforts accurately and prioritize tasks and goals
                                        independently</li>
                                    <li>History of impacting shipping products with your work</li>
                                    <li>A Bachelor’s Degree in Design (or related field) or equivalent professional
                                        experience</li>
                                    <li>Proficiency in a variety of design tools such as Figma, Photoshop, Illustrator, and
                                        Sketch</li>
                                </ul>
                                <h5>Preferred Experience</h5>
                                <ul>
                                    <li>Designing user experiences for enterprise software/services</li>
                                    <li>Creating and applying established design principles and interaction patterns</li>
                                    <li>Aligning or influencing design thinking with teams working in other geographies</li>
                                </ul>
                                <h5>Product Designer</h5>
                                <p><strong>Product knowledge:</strong> Deeply understand the technology and features of the
                                    product area to which you are assigned.</p>
                                <p><strong>Research:</strong> Provide human and business impact and insights for products.
                                </p>
                                <p><strong>Deliverables:</strong> Create deliverables for your product area (e.g.,
                                    competitive analyses, user flows, low fidelity wireframes, high fidelity mockups,
                                    prototypes) that solve real user problems through the user experience.</p>
                                <p><strong>Communication:</strong> Communicate the results of UX activities within your
                                    product area to the design team, cross-functional partners, and other interested team
                                    members using clear language that simplifies complexity.</p>
                        </div>

                            <div className="GAuthor-single">
                                <span>AliThemes</span>
                            </div>

                            <div className="GApply-jobs">
                                <div className="row align-items-center">
                                    <div className="col-md-5">
                                        <a href="#" className="btn btn-primary me-2">Apply now</a>
                                        <a href="#" className="btn btn-outline-secondary">Save job</a>
                                    </div>
                                    <div className="col-md-7 text-md-end social-share">
                                        <a href="#" className="btn btn-outline-primary btn-sm me-2">
                                            <img alt="jobhub" src={mediaUrl + "share-fb.svg?" + sasToken} /> Share
                                        </a>
                                        <a href="#" className="btn btn-outline-info btn-sm me-2">
                                            <img alt="jobhub" src={mediaUrl + "share-tw.svg?" + sasToken} /> Tweet
                                        </a>
                                        <a href="#" className="btn btn-outline-danger btn-sm">
                                            <img alt="jobhub" src={mediaUrl + "share-pinterest.svg?" + sasToken} /> Pin
                                        </a>
                                    </div>

                                </div>
                           </div>
</>
    )

}
export default GJobSingleInfo;